var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apikeyDetail" },
    [
      _vm.$route.query.isApp != 1
        ? _c("van-nav-bar", {
            attrs: { title: "我的API key", "left-arrow": "" },
            on: {
              "click-left": function($event) {
                return _vm.$router.go(-1)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "commont_body" }, [
        _c("div", { staticClass: "page-item" }, [
          _c("div", { staticClass: "item-top" }, [
            _c("div", { staticClass: "item-title" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("9100162")))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.parseTimeData(_vm.pageData.createTime)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-title" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("9100128")))
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.pageData.note))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "item-top" }, [
            _c("div", { staticClass: "item-title" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("9100142")))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("9100131")) +
                    _vm._s(
                      _vm.pageData.freeSpotState ? "、" + _vm.$t("9100132") : ""
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-title" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("9100165")))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.parseTimeData(_vm.pageData.expirationTime || "")
                      ? _vm.parseTimeData(_vm.pageData.expirationTime || "")
                      : "--"
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "item-top" }, [
            _c(
              "div",
              { staticClass: "item-title", staticStyle: { width: "100%" } },
              [
                _c("span", { staticClass: "title" }, [_vm._v("Access Key")]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("span", [_vm._v(_vm._s(_vm.pageData.accessKey) + " ")]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "copy iconfont icon-fuzhi",
                    attrs: { "data-clipboard-text": _vm.pageData.accessKey },
                    on: { click: _vm.handleCopy }
                  })
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "item-top" }, [
            _c(
              "div",
              { staticClass: "item-title", staticStyle: { width: "100%" } },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("9100143")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("span", [_vm._v(_vm._s(_vm.pageData.whiteList || "--"))])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-line" })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flot" },
        [
          _c(
            "Button",
            {
              staticClass: "delect",
              attrs: { color: "rgba(255, 199, 43, 0.05)" },
              on: {
                click: function($event) {
                  _vm.showDelete = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("9100166")))]
          ),
          _vm._v(" "),
          _c(
            "Button",
            { attrs: { color: "#FFC72B" }, on: { click: _vm.goEditApiKey } },
            [_vm._v(_vm._s(_vm.$t("9100164")))]
          ),
          _vm._v(" "),
          !_vm.pageData.whiteList
            ? _c(
                "Button",
                {
                  attrs: { color: "#FFC72B" },
                  on: {
                    click: function($event) {
                      _vm.showNextAPI = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("9100144")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.showDelete,
            callback: function($$v) {
              _vm.showDelete = $$v
            },
            expression: "showDelete"
          }
        },
        [
          _c("p", { staticClass: "modal-title" }, [
            _vm._v("\n            " + _vm._s(_vm.$t("9100150")) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-content" }, [
            _vm._v("\n            " + _vm._s(_vm.$t("9100150")) + "\n        ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell" },
            [
              _c(
                "Button",
                {
                  staticClass: "cancel",
                  attrs: { color: "rgba(0, 0, 0, 0.10)" },
                  on: {
                    click: function($event) {
                      _vm.showDelete = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("300111")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { loading: _vm.delectLoading, color: "#FFC72B" },
                  on: { click: _vm.confirmDelete }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("300287")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.showNextAPI,
            callback: function($$v) {
              _vm.showNextAPI = $$v
            },
            expression: "showNextAPI"
          }
        },
        [
          _c("p", { staticClass: "modal-title" }, [
            _vm._v("\n            " + _vm._s(_vm.$t("9100146")) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-content" }, [
            _vm._v("\n            " + _vm._s(_vm.$t("9100149")) + "\n        ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell" },
            [
              _c(
                "Button",
                {
                  staticClass: "cancel",
                  attrs: { color: "rgba(0, 0, 0, 0.10)" },
                  on: {
                    click: function($event) {
                      _vm.showNextAPI = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("300111")))]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { nextLoading: _vm.nextLoading, color: "#FFC72B" },
                  on: { click: _vm.confirmNextApi }
                },
                [_vm._v(_vm._s(_vm.$t("300287")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0449fe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0449fe2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/apiKey/apikeyDetail.vue
// module id = zm2r
// module chunks = 0